/**
 * Toast Composable
 * Provides toast notification functionality
 */
import { reactive } from 'vue'

// Global toast state
const toast = reactive({
  show: false,
  message: '',
  type: 'success'
})

let timeoutId = null

/**
 * useToast composable
 * @returns {object} Toast utilities
 */
export function useToast() {
  /**
   * Show a toast notification
   * @param {string} message - The message to display
   * @param {string} type - Type: 'success', 'error', 'info', 'warning'
   * @param {number} duration - Duration in ms (default: 3000)
   */
  function showToast(message, type = 'success', duration = 3000) {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    toast.message = message
    toast.type = type
    toast.show = true

    timeoutId = setTimeout(() => {
      toast.show = false
    }, duration)
  }

  /**
   * Hide the current toast
   */
  function hideToast() {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    toast.show = false
  }

  return {
    toast,
    showToast,
    hideToast
  }
}

export default useToast
